import { makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  version: {
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorNeutralForeground4,
    textAlign: 'center',
    padding: tokens.spacingVerticalS,
  },
});

/**
 * Displays the app version in light gray.
 * The version is baked in at build time via VITE_APP_VERSION environment variable.
 */
export function AppVersion() {
  const styles = useStyles();
  const version = import.meta.env.VITE_APP_VERSION || 'dev';

  return <div className={styles.version}>v{version}</div>;
}
